import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';
import Section from '../ui/Section';
import Button from '../ui/Button';
import { Mail, Phone, MapPin } from 'lucide-react';

const Contact = () => {
    const { t } = useLanguage();
    return (
        <Section id="contact" background="slate">
            <div className="grid lg:grid-cols-2 gap-16">
                <div>
                    <h2 className="text-3xl md:text-4xl font-bold mb-6 text-slate-900">{t.contact.getInTouch}</h2>
                    <p className="text-slate-600 text-lg mb-10">
                        {t.contact.description}
                    </p>

                    <div className="space-y-8">
                        <div className="flex items-start gap-4">
                            <div className="bg-white p-3 rounded-lg shadow-sm text-gold-600">
                                <MapPin className="w-6 h-6" />
                            </div>
                            <div>
                                <h3 className="font-bold text-slate-900 mb-1">{t.contact.visitUs}</h3>
                                <p className="text-slate-600">MITROVAČKA 66, 36300<br />Novi Pazar, Srbija</p>
                            </div>
                        </div>

                        <div className="flex items-start gap-4">
                            <div className="bg-white p-3 rounded-lg shadow-sm text-gold-600">
                                <Mail className="w-6 h-6" />
                            </div>
                            <div>
                                <h3 className="font-bold text-slate-900 mb-1">{t.contact.emailUs}</h3>
                                <p className="text-slate-600">kolakovicalija@gmail.com</p>
                            </div>
                        </div>

                        <div className="flex items-start gap-4">
                            <div className="bg-white p-3 rounded-lg shadow-sm text-gold-600">
                                <Phone className="w-6 h-6" />
                            </div>
                            <div>
                                <h3 className="font-bold text-slate-900 mb-1">{t.contact.callUs}</h3>
                                <p className="text-slate-600">+381 63 7376 932</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-white p-8 rounded-xl shadow-lg border border-slate-100">
                    <form className="space-y-6">
                        <div className="grid md:grid-cols-2 gap-6">
                            <div>
                                <label className="block text-sm font-medium text-slate-700 mb-2">{t.contact.firstName}</label>
                                <input
                                    type="text"
                                    className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-gold-500 focus:border-transparent outline-none transition-all"
                                    placeholder={t.contact.placeholderGeneric}
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-slate-700 mb-2">{t.contact.lastName}</label>
                                <input
                                    type="text"
                                    className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-gold-500 focus:border-transparent outline-none transition-all"
                                    placeholder={t.contact.placeholderGeneric}
                                />
                            </div>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-2">{t.contact.email}</label>
                            <input
                                type="email"
                                className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-gold-500 focus:border-transparent outline-none transition-all"
                                placeholder={t.contact.placeholderGeneric}
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-2">{t.contact.message}</label>
                            <textarea
                                rows="4"
                                className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-gold-500 focus:border-transparent outline-none transition-all"
                                placeholder={t.contact.placeholderMessage}
                            ></textarea>
                        </div>

                        <Button variant="primary" className="w-full">
                            {t.contact.sendMessage}
                        </Button>
                    </form>
                </div>
            </div>
        </Section>
    );
};

export default Contact;
